import { useEffect } from "react";

import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import EctLogoSimples from '../../assets/img/favi-ect.png';

interface Props {
  mensagem: string | undefined,
  tipo: string,
  delay: number | undefined,
  show: boolean;
  setShow: (show: boolean) => void;
}


const ToastCustomizado = ({ show, setShow, mensagem, tipo, delay }: Props) => {

  useEffect(() => {
    
    return ()=> {
      //unmount
      setShow(false)
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

    return (
        <>
          {
           
           show ?
            <ToastContainer className="p-3 mb-2" position={'bottom-center'}>
                <Toast onClose={() => setShow(false)} show={show} bg={tipo} delay={delay ? delay : 60000} autohide>
                    <Toast.Header>
                        <img src={EctLogoSimples} 
                             alt="Logo ECT" 
                             className="rounded me-2"
                        />
                        <strong className="me-auto">sroweb</strong>
                    </Toast.Header>
                    <Toast.Body >{mensagem}</Toast.Body>
                </Toast>
            </ToastContainer>

            : null

          }

        </>
    );
}

export default ToastCustomizado;